import axios from "axios";
import { baseURL } from "../../../utils/api";

function createAxios() {
  const profile = JSON.parse(localStorage.getItem("profile"));
  const token = profile?.token?.access;
  return axios.create({
    baseURL: `${baseURL}/coupon`,
    headers: {
      "content-type": "application/json",
      ...(token && { authorization: `Bearer ${token}` }),
    },
  });
}

export const addCouponSlot = (payload) => async (dispatch) => {
  try {
    let API = createAxios();

    const { data } = await API.post("/", payload);

    // dispatch({ type: "Create_Course", payload: { ...data } });
    return data;
  } catch (e) {
    console.error(e);
    return { status: false, msg: e.response?.data?.message || e.message };
  }
};
export const viewCouponByUser = (payload, page = 0) => async (dispatch) => {
  try {
    let API = createAxios();
    const searchQuery = payload === 'All Coupons' ? 'All Coupons' : payload;
    const limit = 10;


    const { data } = await API.get(`/getCoupon?page=${page}&limit=${limit}&search=${encodeURIComponent(searchQuery)}`);


    return data;
  } catch (e) {
    console.error('❌ Coupon API error:', e);
    return { status: false, msg: e.response?.data?.message || e.message };
  }
};

export const viewCouponByCourse = (courseId, page) => async (dispatch) => {
  try {
    let API = createAxios();

    const { data } = await API.get(`/getCouponByCourse/${courseId}`);
    return data;
  } catch (e) {
    console.error(e);
    return { status: false, msg: e.response?.data?.message || e.message };
  }
};


export const deleteCouponSlot = (id) => async (dispatch) => {
  try {
    let API = createAxios();

    const { data } = await API.delete(`/getCoupon/${id}`);

    // dispatch({ type: "Create_Course", payload: { ...data } });
    return data;
  } catch (e) {
    console.error(e);
    return { status: false, msg: e.response?.data?.message || e.message };
  }
};
export const editCouponSlot = (payload, id) => async (dispatch) => {
  try {
    let API = createAxios();

    const { data } = await API.put(`/getCoupon/${id}`, payload);

    // dispatch({ type: "Create_Course", payload: { ...data } });
    return data;
  } catch (e) {
    console.error(e);
    return { status: false, msg: e.response?.data?.message || e.message };
  }
};
